export const REQUEST_CONTEXT_ID = 'request-context';
export const USER_REQUEST_CONTEXT_ID = 'user-request-context';
export const STORE_INFO_REQUEST_CONTEXT_ID = 'store-info-request-context';
export const STORES_REQUEST_CONTEXT_ID = 'stores-request-context';
export const EXPERIMENTS_CONTEXT_ID = 'experiments-context';
export const STORE_PROGRAM_CONTEXT_ID = 'store-program-context';
